"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartBuilders = void 0;
var lib_1 = require("./lib/lib");
var logger_1 = require("./logger");
var data_1 = require("./data");
var startedBuilders = [];
var StartBuilders = function () {
    // if (isSimulated) {
    //   return;
    // }
    data_1.Builders.forEach(function (builderKey) {
        var key = builderKey;
        var element = document.querySelector("#".concat(key, " .fill"));
        var animate = function () {
            return element
                .animate([{ width: "0%" }, { width: "100%" }], { duration: data_1.Items[key].intervalSeconds * 1000 })
                .addEventListener("finish", function () {
                element.style.width = "100%";
            });
        };
        if (data_1.GameData.itemLevel[key] > 0 && !startedBuilders.includes(key)) {
            animate();
            setInterval(function () {
                AddBuilderBricks(key);
                animate();
            }, data_1.Items[key].intervalSeconds * 1000);
            startedBuilders.push(key);
            logger_1.Logger.log("Builder started: " + key);
        }
    });
};
exports.StartBuilders = StartBuilders;
var AddBuilderBricks = function (item) {
    var bricksToAdd = data_1.GameData.itemLevel[item];
    (0, lib_1.AddBricks)(bricksToAdd);
};
